(function() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const q = (params.get('q') || '').toLowerCase().trim();

  const redirects = [
    { match: 'easter', url: '/collections/easter-embroidery-designs' },
    { match: 'in the hoop', url: '/collections/in-the-hoop-embroidery-designs' },
    { match: 'ith', url: '/collections/in-the-hoop-embroidery-designs' },
    { match: 'embossed', url: '/collections/embossed-embroidery-designs' },
    { match: 'patriotic', url: '/collections/patriotic-independence-day-usa-designs' },
    { match: 'flowers', url: '/collections/flower-embroidery-designs' },
    { match: 'flower', url: '/collections/flower-embroidery-designs' },
    { match: 'butterfly', url: '/collections/butterfly-moth-embroidery-designs' },
    { match: 'christmas', url: '/collections/christmas-embroidery-designs' },
    { match: 'beach', url: '/collections/beach-tropical-embroidery-designs' },
    { match: 'cat', url: '/collections/cat-embroidery-designs' },
    { match: 'cats', url: '/collections/cat-embroidery-designs' },
    { match: 'borders', url: '/collections/border-embroidery-designs' },
    { match: 'baby', url: '/collections/baby-nursery-embroidery-designs' },
    { match: 'babys', url: '/collections/baby-nursery-embroidery-designs' },
    { match: 'chicken', url: '/collections/chicken-hen-rooster-embroidery-designs' },
    { match: 'chickens', url: '/collections/chicken-hen-rooster-embroidery-designs' },
    { match: 'dog', url: '/collections/dog-embroidery-designs' },
    { match: 'summer', url: '/collections/summer-season' },
    { match: 'bee', url: '/collections/bees' },
    { match: 'bees', url: '/collections/bees' },
    { match: 'dogs', url: '/collections/dog-embroidery-designs' },
    { match: 'applique', url: '/collections/applique-embroidery-designs' }
  ];

  if (path.includes('/a/search') || path.includes('/search')) {
    for (let r of redirects) {
      if (q === r.match) {
        window.location.replace(r.url);
        break;
      }
    }
  }
})();